// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 245 ? "component---src-pages-index-tsx" : chunkId) + "-" + {"245":"1d46979aa5da36f7b27b","522":"b080e890d0d93c3b3875"}[chunkId] + ".js";
};